/* global axios */
import ApiClient from './ApiClient';

class AiAgentsAPI extends ApiClient {
  constructor() {
    super('ai/agents', { accountScoped: true, apiVersion: 'v2' });
  }

  // O controller espera os campos sob a chave `ai_agent` (params.require(:ai_agent)).
  create(data) {
    return axios.post(this.url, { ai_agent: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { ai_agent: data });
  }

  testConnection(id) {
    return axios.post(`${this.url}/${id}/test_connection`);
  }

  // Config de IA da CONTA — não é de agente nenhum, por isso mora fora do
  // /ai/agents. Hoje só as etiquetas que calam todos os agentes.
  getAccountSettings() {
    return axios.get(this.url.replace(/\/agents$/, '/settings'));
  }

  updateAccountSettings(data) {
    return axios.patch(this.url.replace(/\/agents$/, '/settings'), data);
  }
}

export default new AiAgentsAPI();
